import { createStore } from "vuex";
import user from "./modules/user";
import permission from "./modules/permission";
import eventlive from "./modules/eventlive";
import neweventlive from "./modules/neweventlive";
import { getBeijingTimestamp } from "@/utils/common";
import Cookies from "js-cookie";
import { getVisitor } from "@/api/base";

let currentLocale = "cn";
if (
  window.location.pathname.indexOf("/en") == 0 ||
  window.location.hostname == "visitor.sialchina.com"
) {
  currentLocale = "en";
}

const store = createStore({
  state: {
    currentLang: currentLocale,
    domain: process.env.VUE_APP_HOST, // 当前项目域名
    domain_en: process.env.VUE_APP_EN_HOST,
    api_domain:
      currentLocale == "en"
        ? process.env.VUE_APP_API_EN_DOMAIN
        : process.env.VUE_APP_API_DOMAIN, // 不进行代理的接口域名

    home_domain: "https://www.sialchina.cn",
    home_domain_en: "https://www.sialchina.com",
    visitor_domain: "https://visitor.sialchina.cn",
    visitor_domain_en: "https://visitor.sialchina.com",
    qrcode_origin: `${
      currentLocale == "en"
        ? process.env.VUE_APP_API_EN_DOMAIN
        : process.env.VUE_APP_API_DOMAIN
    }/api/getQrcode?text=`,

    // 注册通道
    close_reg:
      getBeijingTimestamp() >= new Date("2024-09-01T07:00:00.000Z").getTime(), // 关闭注册
    is_now_ids: [2], // 当前可以注册的展会id
    reg_info: Cookies.get("sh_pre_info")
      ? JSON.parse(Cookies.get("sh_pre_info"))
      : { prereg_status: true },
    visitorInfo: {},
  },
  modules: {
    user,
    permission,
    eventlive,
    neweventlive,
  },
  getters: {
    isLogin: (state) => state.user.isLogin,
    truename: (state) => state.user.truename,
    is_need_completion_certificates: (state) =>
      state.user.is_need_completion_certificates,
    is_need_completion_survey: (state) => state.user.is_need_completion_survey,
    expo_list: (state) => state.user.expo_list,
    roles: (state) => state.user.roles,
    hasAuth: (state) => state.permission.hasAuth,
    permissionRoutes: (state) => state.permission.routes,

    // 旧峰会
    eventlive_show_login: (state) => state.eventlive.eventlive_show_login,
    eventlive_show_reg: (state) => state.eventlive.eventlive_show_reg,
    eventlive_show_finish: (state) => state.eventlive.eventlive_show_finish,

    // 新峰会购票
    neweventlive_show_login: (state) => state.neweventlive.eventlive_show_login,
    neweventlive_show_profile: (state) =>
      state.neweventlive.eventlive_show_profile,
    is_login_neweventlive: (state) => state.neweventlive.isLogin,
    neweventlive_truename: (state) => state.neweventlive.truename,

    // 新配对
    show_special_menu: (state) => state.user.show_special_menu,
    precise_match_booth_open: (state) => state.user.precise_match_booth_open,
    precise_match_buyer_open: (state) => state.user.precise_match_buyer_open,
  },
  mutations: {
    SET_CURRENT_LANG(state, lang) {
      state.currentLang = lang;
    },
    SET_CLOSE_REG(state, val) {
      state.close_reg = val;
    },
    SET_NOW_REG_INFO(state, data) {
      state.reg_info = data;
    },
    SET_NOW_EXPO_IDS(state, data) {
      state.is_now_ids = data;
    },
    SET_VISITOR_INFO(state, data) {
      state.visitorInfo = data;
    },
  },
  actions: {
    async getVisitorInfo({ commit, state }) {
      if (Object.keys(state.visitorInfo).length == 0) {
        try {
          const { data } = await getVisitor();
          // console.log('--data', data);
          commit("SET_VISITOR_INFO", data.visitor);
        } catch (error) {}
      }
      return state.visitorInfo;
    },
  },
});

export default store;
